import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styles from './Header.module.scss'
import MainSearch from '../../components/mainSearch/MainSearch.jsx'
import { useMedia } from 'react-use'
import { routes, mainMenu, mainMenuRules } from '../../imports/config'
import { useHistory, useLocation, Link, matchPath } from 'react-router-dom'
import { find } from 'lodash'
import BackArrowIcon from '../../assets/icons/arrow_back-24px.svg'
import ShareIcon from '../../assets/icons/share-24px.svg'
import HeartFilledIcon from '../../assets/icons/favorite-24px.svg'
import HeartIcon from '../../assets/icons/favorite_border-24px.svg'
import { useLocalStorage } from 'react-use'
import Logo from '../../assets/images/logo.png'
import Calendar from '../customIcons/Calendar'
import List from '../customIcons/List'
import { AppName } from '../../imports/constants'

import {
    toggleFavoriteItem,
    toggleFavoriteItemProfile,
} from '../../imports/utils'

const RenderMenu = ({ role, location, name, surname }) => {
    const { t } = useTranslation()

    return (
        <div className={styles.pagesLinks}>
            {mainMenuRules()[role].map((item, index) => {
                if (mainMenuRules()[role][index].visibility.includes('d')) {
                    const text =
                        role !== 'guest' && item.key === 'profile'
                            ? `${name} ${surname}`
                            : t(mainMenu[item.key].text)

                    let linkObj = {
                        pathname: mainMenu[item.key].url,
                    }

                    if (mainMenu[item.key].params) {
                        linkObj.state = mainMenu[item.key].params
                    }

                    let isSelected =
                        location.pathname === mainMenu[item.key].url

                    if (
                        isSelected &&
                        (location.state || mainMenu[item.key].params)
                    ) {
                        isSelected =
                            mainMenu[item.key].params === location.state
                    }

                    return (
                        <Link key={mainMenu[item.key].text} to={linkObj}>
                            <div
                                className={`${
                                    isSelected ? styles.selectedLink : ''
                                } ${styles.menuLink}`}
                            >
                                {text}
                            </div>
                        </Link>
                    )
                } else {
                    return null
                }
            })}
        </div>
    )
}

const HeaderAction = ({ actionId, title, user, updateWishlist, ...props }) => {
    const history = useHistory()
    const location = useLocation()
    const { t } = useTranslation()
    const [savedFavorites, setFavorites, removeFavorites] = useLocalStorage(
        'favoriteCoworkings'
    )

    switch (actionId) {
        case 'back':
            return (
                <div
                    key={actionId}
                    className={`${styles[actionId]} ${styles.action}`}
                    onClick={() => history.goBack()}
                >
                    <img alt={t('go_back_icon')} src={BackArrowIcon} />
                    {title && (
                        <h2 className={styles.headerTitle}> {t(title)} </h2>
                    )}
                </div>
            )
        case 'share':
            return (
                <div
                    className={`${styles[actionId]} ${styles.action}`}
                    key={actionId}
                >
                    <a
                        href={`https://api.whatsapp.com/send?text=${window.location.href}`}
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <img
                            alt={t('share_icon')}
                            src={ShareIcon}
                            className={styles.icon}
                        />
                    </a>
                </div>
            )

        case 'favorite':
            const coworkingId =
                location.pathname.match('/coworking/(.*)')[1] || null
            return (
                coworkingId && (
                    <div
                        key={actionId}
                        className={`${styles[actionId]} ${styles.action}`}
                        onClick={() =>
                            user
                                ? updateWishlist(
                                      toggleFavoriteItemProfile(
                                          user.wishlist,
                                          coworkingId
                                      )
                                  )
                                : toggleFavoriteItem(
                                      savedFavorites,
                                      setFavorites,
                                      removeFavorites,
                                      coworkingId
                                  )
                        }
                    >
                        <img
                            src={
                                (user &&
                                    user?.wishlist?.includes(coworkingId)) ||
                                (!user &&
                                    savedFavorites &&
                                    JSON.parse(savedFavorites).includes(
                                        coworkingId
                                    ))
                                    ? HeartFilledIcon
                                    : HeartIcon
                            }
                            alt={t('saved_icons')}
                        />
                    </div>
                )
            )
        case 'reservationView':
            return (
                <div
                    key={actionId}
                    className={`${styles[actionId]} ${styles.action}`}
                    onClick={() =>
                        props.updateOptions(
                            'reservationView',
                            `${
                                props.reservationView === 'grid'
                                    ? 'calendar'
                                    : 'grid'
                            }`
                        )
                    }
                >
                    {title && (
                        <h2 className={styles.headerTitle}> {t(title)} </h2>
                    )}
                    <span className={styles.wrapperIcon}>
                        {props.reservationView === 'calendar' ? (
                            <List className={styles.icon} />
                        ) : (
                            <Calendar className={styles.icon} />
                        )}
                    </span>
                </div>
            )
        default:
            return null
    }
}

const HomeLogo = ({ isSearch }) => {
    const { t } = useTranslation()

    return (
        <Link to='/' className={`${styles.logoWrapper} ${styles.isBeta}`}>
            <img src={Logo} className={styles.logo} alt={t('logo')} />
            {!isSearch && <div className={styles.appName}>{AppName}</div>}
        </Link>
    )
}

const Header = props => {
    const isMobile = useMedia('(max-width: 767px)')
    const location = useLocation()

    const pageWithSearch = ['/']

    const actualPath = find(routes, route =>
        matchPath(location.pathname, { path: route.path, exact: true })
    )

    const headerActions =
        props.user?.role === 'owner' && actualPath?.ownerHeaderActionsMobile
            ? actualPath?.ownerHeaderActionsMobile
            : actualPath?.headerActionsMobile
            ? actualPath?.headerActionsMobile
            : null

    const headerTitle =
        props.user?.role === 'owner' && actualPath?.ownerHeaderTitle
            ? actualPath?.ownerHeaderTitle
            : actualPath?.headerTitle
            ? actualPath?.headerTitle
            : null

    let isSearch =
        pageWithSearch.includes(actualPath.path) &&
        (props.user?.role === 'coworker' || !props.user?.role)

    if (actualPath.path === '/' && !props.filters.city) {
        isSearch = false
    }

    return (
        <div
            className={`${styles.headerWrapper} ${
                isSearch ? styles.search : ''
            }`}
        >
            <div className={styles.headerContainer}>
                {(!isMobile || (isMobile && !headerActions)) && (
                    <HomeLogo isSearch={isSearch} />
                )}
                {isSearch && (!isMobile || (isMobile && !headerActions)) && (
                    <MainSearch />
                )}
                {!isMobile ? (
                    <div className={styles.mainMenuDesktop}>
                        {props.user?.role ? (
                            <>
                                <RenderMenu
                                    location={location}
                                    role={props.user?.role}
                                    name={props.user?.name}
                                    surname={props.user?.surname}
                                />
                            </>
                        ) : (
                            <RenderMenu location={location} role='guest' />
                        )}
                    </div>
                ) : (
                    isMobile &&
                    headerActions?.length > 0 &&
                    headerActions && (
                        <div className={styles.actionsBarWrapper}>
                            {headerActions.map(item => {
                                return (
                                    <HeaderAction
                                        key={item}
                                        actionId={item}
                                        title={headerTitle}
                                        user={props.user}
                                        updateWishlist={props.updateWishlist}
                                        updateOptions={props.updateOptions}
                                        reservationView={props.reservationView}
                                    />
                                )
                            })}
                        </div>
                    )
                )}
            </div>
        </div>
    )
}

export default connect(state => {
    return {
        reservationView: state.options.reservationView,
        filters: state.coworking.activeFilters,
    }
})(Header)
